import { render, staticRenderFns } from "./selectInfo.vue?vue&type=template&id=06b8d1be&"
import script from "./selectInfo.vue?vue&type=script&lang=js&"
export * from "./selectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports